module.exports = __webpack_public_path__ + "static/media/nas.6a698b83.svg";